import { render } from "./CreateGatepass.vue?vue&type=template&id=31448342&scoped=true"
import script from "./CreateGatepass.vue?vue&type=script&lang=js"
export * from "./CreateGatepass.vue?vue&type=script&lang=js"

import "./CreateGatepass.vue?vue&type=style&index=0&id=31448342&scoped=true&lang=css"
import "./CreateGatepass.vue?vue&type=style&index=1&id=31448342&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31448342"]])

export default __exports__